import IMask from "imask"
import moment from "moment-timezone"

import type { InputMaskConfigs } from "@front-shared/types/objects.types"

import { FRONT_GENERAL_CONFIG } from "./general.config"

export const FRONT_INPUT_MASK_VALIDATION_FUNCTIONS = {
    date: {
        format: (date: any) => {
            return moment(date).format(
                FRONT_GENERAL_CONFIG.defaultMomentDateFormat,
            )
        },
        parse: (str: any) => {
            return moment(
                str,
                FRONT_GENERAL_CONFIG.defaultMomentDateFormat,
            ).toDate()
        },
    },
}

export const FRONT_INPUT_MASKS_CONFIG: Partial<InputMaskConfigs> = {
    dob: {
        pattern: FRONT_GENERAL_CONFIG.defaultMomentDateFormat,
        lazy: true,
        // @ts-ignore
        min: new Date(1900, 0, 1),
        // @ts-ignore
        max: new Date(),
        format: FRONT_INPUT_MASK_VALIDATION_FUNCTIONS.date.format,
        parse: FRONT_INPUT_MASK_VALIDATION_FUNCTIONS.date.parse,
        blocks: {
            YYYY: {
                mask: IMask.MaskedRange,
                from: 1900,
                to: new Date().getFullYear(),
            },
            MM: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 12,
            },
            DD: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 31,
            },
        },
    },
}
